import { Grid, IconButton } from '@material-ui/core';
import React from 'react';
import { apiUrl } from '../../../../common/constants/apiUrl';
import { ImageDto } from '../../groupVisits.dtos';
import DeleteIcon from '@material-ui/icons/HighlightOffSharp';
import theme from '../../../../common/themes/theme';

interface IProps {
  onClick: (image: string, type: string) => void;
  image: ImageDto;
  onSelect: (image: ImageDto) => void;
}

const ImageCard: React.FC<IProps> = ({ onClick, image, onSelect }) => {
  const url = `${apiUrl}/groupVisits/image/${image.imageFileName}`;
  return (
    <Grid
      item
      style={{
        width: '250px',
        margin: '30px',
        height: 'auto',
        position: 'relative',
      }}
    >
      <IconButton
        aria-label='Delete'
        onClick={() => onSelect(image)}
        style={{
          position: 'absolute',
          right: 0,
          backgroundColor: '#1212128c',
          color: 'white',
          padding: '5px',
          zIndex: 10,
        }}
      >
        <DeleteIcon />
      </IconButton>
      {image.mimeType == 'image/jpg' || image.mimeType == 'image/jpeg' ? (
        <img
          src={url}
          alt='group image'
          style={{ width: '100%' }}
          onClick={() => {
            onClick(url, image.mimeType);
          }}
        />
      ) : (
        <video
          src={url}
          style={{ width: '100%' }}
          onClick={() => {
            onClick(url, image.mimeType);
          }}
          controls
        />
      )}
    </Grid>
  );
};

export default ImageCard;
